import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initStaffCardsGrid() {
  Alpine.data(
    'staffCardsGrid',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sw-staffCards');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 10,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
              centeredSlides: true,
              autoHeight: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 4,
              loop: false,
              autoHeight: false,
              autoplay: false,
            },
          },
        });
      },
    }),
  );
}
